import pbfe from "./pbfe.js";
import { _, t } from "./i18n.js";
import createNavbar from "./navbar.js";
import { LANG_URL_MAP, getLang, navigate as routeTo } from "./index.js";
import { getPostBySlug } from "./blog-posts.js";

var container, box;

function init(_container, slug) {
    if (_container) {
        container = _container;
    }
    
    // Clear previous content if needed
    if (box && box.element) {
        box.element.innerHTML = "";
    } else {
        box = new pbfe.Flexbox("column");
        box.element.id = "blogPostScreen";
        box.element.className = "main-screen";
    }
    
    var post = getPostBySlug(slug);
    
    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    // Content Container
    var contentBox = new pbfe.Flexbox("column");
    contentBox.element.id = "blogPostContentBox";
    contentBox.alignItems = "center";
    
    // Breadcrumb Container
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";
    
    // Breadcrumb
    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);
    
    // Home Link
    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    t(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", () => {
        navigate("/");
    });
    breadcrumb.appendChild(homeLink);
    
    // Separator
    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);
    
    // Blog Link
    var blogLink = document.createElement("a");
    blogLink.className = "breadcrumb-link";
    blogLink.innerText = "";
    t(blogLink, "Blog");
    blogLink.addEventListener("click", () => {
        navigate("/blog");
    });
    breadcrumb.appendChild(blogLink);
    
    // Separator
    var separator2 = document.createElement("span");
    separator2.className = "breadcrumb-separator";
    separator2.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator2);
    
    // Current Page
    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    current.innerText = post ? post.title : "Not Found";
    breadcrumb.appendChild(current);
    
    contentBox.appendChild({ element: breadcrumbContainer });
    
    if (post) {
        // Article Container
        var article = document.createElement("article");
        article.className = "blog-article";
        
        // Header
        var header = document.createElement("header");
        header.className = "blog-article-header";
        
        var title = document.createElement("h1");
        title.className = "blog-article-title";
        title.innerText = post.title;
        header.appendChild(title);
        
        var meta = document.createElement("div");
        meta.className = "blog-article-meta";
        meta.innerHTML = `
            <span>📅 ${post.date}</span>
            <span>⏱ ${post.readTime} <span class="min-read-text"></span></span>
            <span style="color: ${post.color}; font-weight: 700;">${post.category}</span>
        `;
        t(meta.querySelector(".min-read-text"), "min read");
        header.appendChild(meta);
        
        article.appendChild(header);
        
        // Content
        var body = document.createElement("div");
        body.innerHTML = post.content;
        article.appendChild(body);
        
        contentBox.appendChild({ element: article });
    } else {
        // Not Found State
        var notFound = document.createElement("div");
        notFound.style.padding = "4rem";
        notFound.style.textAlign = "center";
        notFound.style.color = "#fff";
        notFound.innerText = "Post not found";
        contentBox.appendChild({ element: notFound });
    }

    box.appendChild(contentBox);
}

function navigate(path) {
    var lang = getLang();
    var prefix = LANG_URL_MAP[lang];
    var fullPath = prefix ? "/" + prefix + path : path;
    if (path === "/") {
         fullPath = prefix ? "/" + prefix : "/";
    }
    
    routeTo(fullPath);
}

function show() {
    container.appendChild(box);
    setTimeout(() => box.element.classList.add("show"), 0);
}

function hide() {
    if (!box) return;
    box.element.classList.remove("show");
    if (container && container.contains(box)) {
        container.removeChild(box);
    }
}

var blogPostScreen = {
    init, show, hide
};

export default blogPostScreen;
